import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UserConfig = () => {
  const [users, setUsers] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [selectedContractors, setSelectedContractors] = useState({});
  const [defaultContractors, setDefaultContractors] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [usersResponse, contractorsResponse, configsResponse] = await Promise.all([
        axios.get('https://bank2.daolog.net/users'),
        axios.get('https://bank2.daolog.net/contractors'),
        axios.get('https://bank2.daolog.net/user-configs')
      ]);

      setUsers(usersResponse.data);
      setContractors(contractorsResponse.data);

      const configsMap = {};
      const defaultContractorsMap = {};
      configsResponse.data.forEach(config => {
        configsMap[config.user_id] = config.contractors_id || [];
        defaultContractorsMap[config.user_id] = config.default_contractor_id || null;
      });
      setSelectedContractors(configsMap);
      setDefaultContractors(defaultContractorsMap);
    } catch (error) {
      console.error('Помилка отримання даних:', error);
    }
  };

  const handleAddContractor = async (userId, contractorId) => {
    try {
      await axios.post(`https://bank2.daolog.net/add-contractor-to-user/${userId}`, {
        userId,
        contractorId: contractorId.toString()
      });
      fetchData();
    } catch (error) {
      console.error('Помилка додавання контрагента:', error);
    }
  };

  const handleRemoveContractor = async (userId, contractorId) => {
    try {
      await axios.delete(`https://bank2.daolog.net/remove-contractor-from-user/${userId}/${contractorId}`);
      fetchData();
    } catch (error) {
      console.error('Помилка видалення контрагента:', error);
    }
  };

  const handleSetDefaultContractor = async (userId, contractorId) => {
    try {
      await axios.post(`https://bank2.daolog.net/set-default-contractor`, {
        userId,
        contractorId: contractorId.toString()
      });
      fetchData();
    } catch (error) {
      console.error('Помилка встановлення контрагента за замовчуванням:', error);
    }
  };

  const handleAddToUserConfig = async (userId) => {
    try {
      await axios.post('https://bank2.daolog.net/add-to-user-config', {
        userId
      });
      alert('Дані успішно додано до таблиці');
    } catch (error) {
      console.error('Помилка додавання даних до таблиці:', error);
      alert('Помилка додавання даних до таблиці');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Налаштування користувачів</h1>
      {users.map(user => (
        <div key={user.id} style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd' }}>
          <h2>{user.username}</h2>
          
          <div>
            <h3>Контрагент за замовчуванням:</h3>
            <div style={{ marginBottom: '15px' }}>
              {contractors
                .filter(contractor => contractor.id.toString() === defaultContractors[user.id])
                .map(contractor => (
                  <div key={contractor.id} style={{
                    padding: '10px',
                    border: '1px solid #ccc',
                    backgroundColor: '#ffe6e6',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}>
                    <span>{contractor.name}</span>
                    <button
                      onClick={() => handleAddToUserConfig(user.id)}
                      style={{
                        padding: '5px 10px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer'
                      }}
                    >
                      Додати дані до таблиці
                    </button>
                  </div>
                ))}
            </div>
          </div>

          <div>
            <h3>Додані контрагенти:</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {contractors
                .filter(contractor => selectedContractors[user.id]?.includes(contractor.id.toString()))
                .map(contractor => (
                  <div key={contractor.id} style={{
                    padding: '10px',
                    border: '1px solid #ccc',
                    backgroundColor: '#e6f3ff'
                  }}>
                    <span>{contractor.name}</span>
                    <button
                      onClick={() => handleSetDefaultContractor(user.id, contractor.id)}
                      style={{
                        marginLeft: '10px',
                        padding: '5px 10px',
                        backgroundColor: '#ffa500',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer'
                      }}
                    >
                      За замовчуванням
                    </button>
                    <button
                      onClick={() => handleRemoveContractor(user.id, contractor.id)}
                      style={{
                        marginLeft: '10px',
                        padding: '5px 10px',
                        backgroundColor: '#ff4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer'
                      }}
                    >
                      Видалити
                    </button>
                  </div>
                ))}
            </div>
          </div>

          <div>
            <h3>Доступні контрагенти:</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {contractors
                .filter(contractor => !selectedContractors[user.id]?.includes(contractor.id.toString()))
                .map(contractor => (
                  <div key={contractor.id} style={{
                    padding: '10px',
                    border: '1px solid #ccc',
                    backgroundColor: 'white'
                  }}>
                    <span>{contractor.name}</span>
                    <button
                      onClick={() => handleAddContractor(user.id, contractor.id)}
                      style={{
                        marginLeft: '10px',
                        padding: '5px 10px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer'
                      }}
                    >
                      Додати
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserConfig;